import actions from './actions';

const select = channel => actions.selected(channel);

const triggers = {
  select
};

export default triggers;
